/**
 * The viewer's motion preference, on its own: the eager React shell and the
 * "my visit" script both read it without pulling in the canvas loop.
 *
 * Plan: docs/plans/2026-10-22-owl-waits-everywhere.md
 */
/** Nothing moves for people who asked for less motion. */
export function prefersReducedMotion() {
    try {
        return typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    }
    catch {
        return false;
    }
}
